import type { FelicitacionStepProps } from "./config";
import IllustratedStepCard from "./IllustratedStepCard";
import step4EnvelopeImage from "../../../assets/images/felicitacion/mockup3_v2.webp";

const Step4 = ({ selectedGrandpa }: FelicitacionStepProps) => {
	return (
		<IllustratedStepCard
			cardPadding="0 24px 24px"
			copyPadding="24px 0 0"
			description="En la parte trasera de la tarjeta, donde pone “remitente”. Así correos podrá enviártela de vuelta si se pierde."
			imageAlign="flex-start"
			imageAlt={`Carta con la dirección de ${selectedGrandpa?.name ?? "la persona mayor"}`}
			imageCompactMaxHeight="380px"
			imageCompactWidth="300px"
			imageJustify="center"
			imageMarginTop="0"
			imageMaxHeight="clamp(420px, 58vh, 560px)"
			imageSrc={step4EnvelopeImage}
			imageHeight="auto"
			reverseOrder={true}
			title="Añade tu dirección"
		/>
	);
};

export default Step4;
